import React, { useState } from 'react';
import './footer-layout.scss';
import DSSModal from '../../../../ui/building-blocks/atoms/dss-modal';
import PrivacyStatementModal from './privacy-statement-modal';
import SupportedBrowsersModal from './supported-browsers-modal';

//@ts-expect-error
const links = window.ENV;

export const FooterLayout = () => {
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);
    const [showSupportedModal, setShowSupportedModal] = useState(false);

    const footerLinks = [
        { text: 'Supported Browsers', link: '', icon: '' },
        { text: 'Privacy Statement', link: links.PRIVACY_POLICY, icon: "" },
        { text: 'Your Privacy Choices', link: links.YOUR_PRIVACY_CHOICES, icon: links.YOUR_PRIVACY_CHOICES_ICON },
        { text: 'Cookie Notice', link: links.COOKIE_NOTICE, icon: "" },

    ];
    return (
        <div className='footer-layout'>
            <div className='section-2 '>
                <div className='footer-text'>© 2026 INDS. All rights reserved.</div>
                <div className='footer-links'>
                    {footerLinks.map((item, index) => (
                        <React.Fragment key={index}>
                            {item.text === "Privacy Statement" ? (
                                <a
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        setShowPrivacyModal(true);
                                    }}
                                >
                                    {item.text} {item.icon && <img src={item.icon} alt={item.text} />}
                                </a>
                            ) : item.text === "Supported Browsers" ? (
                                <a
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        setShowSupportedModal(true);
                                    }}
                                >
                                    {item.text}
                                </a>
                            ) : (
                                <a target="_blank" rel="noopener noreferrer" href={item.link}>
                                    {item.text} {item.icon && <img src={item.icon} alt={item.text} />}
                                </a>
                            )}
                            {index < footerLinks.length - 1 && <span className="seperator"></span>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <DSSModal
                id="privacy-statement-modal"
                isOpen={showPrivacyModal}
                isShowClose={false}
            >
                <PrivacyStatementModal onClose={() => setShowPrivacyModal(false)}
                    honeywellPolicy={links.PRIVACY_POLICY}
                    jeppesenPolicy={links.JEPPESEN_PRIVACY_POLICY}


                />
            </DSSModal>
            <DSSModal
                id="privacy-statement-modal"
                isOpen={showSupportedModal}
                isShowClose={false}
            >
                <SupportedBrowsersModal onClose={() => setShowSupportedModal(false)} />
                    
            </DSSModal>
        </div>
    );
}